import { actions } from "../actions";
import {
  CorpLodging,
  CorpRoomInfoProducts,
  Lodging,
  OpaqueValue,
  RoomInfoProducts,
  TrackingProperties,
  CancellationSummary,
  LodgingTokenResponse,
  IPersistentLodgingTrackingProperties,
} from "redmond";
import {
  FETCH_PREMIER_COLLECTION_SHOP,
  SET_PREMIER_COLLECTION_SHOP_RESULTS,
  SELECT_ROOM_TYPE,
  ACKNOWLEDGE_PREMIER_COLLECTION_SHOP_FAILURE,
  SELECT_LODGING,
  SET_PREMIER_COLLECTION_SHOP_CALL_STATE_FAILED,
  SET_PREMIER_COLLECTION_SHOP_PROGRESS,
  SET_IS_FROM_HOTEL_AVAILABILITY,
  SET_CACHE_LODGING_TOKEN_RESPONSE,
  SET_IS_FROM_PREMIUM_OFFERS,
  SET_PERSISTENT_LODGING_TRACKING_PROPERTIES,
  SET_SELECTED_LODGING_IS_FAVORITED,
  SET_HOTEL_DETAILS_ENTRY_SOURCE,
  SET_ALLOWED_PAY_LATER_LODGING_IDS,
  SET_LIFESTYLE_ELIGIBILITY,
} from "../actions/constants";
export interface IPremierCollectionShopState {
  selectedLodging: Lodging | CorpLodging | null;
  shopRequestId: OpaqueValue | null;
  roomInfoProducts: RoomInfoProducts[] | CorpRoomInfoProducts[];
  chosenRoomInfoIndex: number | null;
  chosenProductIndex: number | null;
  allowedPayLaterLodgingIds: string[];
  premierCollectionShopCallState: PremierCollectionShopCallState;
  premierCollectionShopCallError: PremierCollectionShopCallError | null;
  progress: PremierCollectionShopStep;
  isFromHotelAvailability: boolean;
  hotelShopTrackingPropertiesV2: TrackingProperties | null;
  cancellationSummary: CancellationSummary | null;
  cacheLodgingTokenResponse?: LodgingTokenResponse;
  isFromPremiumOffers?: boolean;
  persistentLodgingTrackingProperties?: IPersistentLodgingTrackingProperties;
  selectedLodgingIsFavorited?: boolean;
  hotelDetailsEntrySource?: string;
  isLifestyleEligible: boolean | null;
}

export enum PremierCollectionShopStep {
  HotelInfo,
  ChooseRoom,
}

export enum PremierCollectionShopCallState {
  NotCalled = "NotCalled",
  InProcess = "InProcess",
  Success = "Success",
  Failed = "Failed",
  FailureAcknowledged = "FailureAcknowledged",
}

export enum PremierCollectionShopCallError {
  NoAvailability = "NoAvailability",
  Unknown = "Unknown",
}

const initialState: IPremierCollectionShopState = {
  selectedLodging: null,
  shopRequestId: null,
  roomInfoProducts: [],
  chosenRoomInfoIndex: null,
  chosenProductIndex: null,
  allowedPayLaterLodgingIds: [],
  premierCollectionShopCallState: PremierCollectionShopCallState.NotCalled,
  premierCollectionShopCallError: null,
  progress: PremierCollectionShopStep.HotelInfo,
  isFromHotelAvailability: false,
  hotelShopTrackingPropertiesV2: null,
  cancellationSummary: null,
  isFromPremiumOffers: false,
  persistentLodgingTrackingProperties: undefined,
  isLifestyleEligible: null,
};

export const reducer = (
  state: IPremierCollectionShopState = initialState,
  action: actions.PremierCollectionShopActions
): IPremierCollectionShopState => {
  switch (action.type) {
    case FETCH_PREMIER_COLLECTION_SHOP:
      return {
        ...state,
        roomInfoProducts: [],
        premierCollectionShopCallState:
          PremierCollectionShopCallState.InProcess,
        premierCollectionShopCallError: null,
      };

    case SET_IS_FROM_HOTEL_AVAILABILITY:
      return {
        ...state,
        isFromHotelAvailability: action.isFromHotelAvailability,
      };

    case SET_PREMIER_COLLECTION_SHOP_RESULTS:
      return {
        ...state,
        chosenRoomInfoIndex: null,
        chosenProductIndex: null,
        premierCollectionShopCallState: action.premierCollectionShopCallState,
        premierCollectionShopCallError: action.premierCollectionShopCallError,
        ...action.payload,
        hotelShopTrackingPropertiesV2:
          action.payload?.trackingPropertiesV2 ??
          state.hotelShopTrackingPropertiesV2,
      };

    case SET_PREMIER_COLLECTION_SHOP_CALL_STATE_FAILED:
      return {
        ...state,
        premierCollectionShopCallState: PremierCollectionShopCallState.Failed,
        premierCollectionShopCallError: action.premierCollectionShopCallError,
      };

    case SELECT_ROOM_TYPE:
      return {
        ...state,
        chosenRoomInfoIndex: action.roomInfoIndex,
        chosenProductIndex: action.productIndex,
      };

    case SELECT_LODGING:
      return {
        ...state,
        selectedLodging: action.lodging,
      };

    case ACKNOWLEDGE_PREMIER_COLLECTION_SHOP_FAILURE:
      return {
        ...state,
        premierCollectionShopCallState:
          PremierCollectionShopCallState.FailureAcknowledged,
      };
    case SET_PREMIER_COLLECTION_SHOP_PROGRESS: {
      return {
        ...state,
        progress: action.progress,
      };
    }

    case SET_CACHE_LODGING_TOKEN_RESPONSE:
      return {
        ...state,
        cacheLodgingTokenResponse: action.lodgingTokenResponse,
      };

    case SET_IS_FROM_PREMIUM_OFFERS:
      return {
        ...state,
        isFromPremiumOffers: action.isFromPremiumOffers,
      };

    case SET_PERSISTENT_LODGING_TRACKING_PROPERTIES:
      return {
        ...state,
        persistentLodgingTrackingProperties:
          action.persistentLodgingTrackingProperties,
      };
    case SET_SELECTED_LODGING_IS_FAVORITED:
      return {
        ...state,
        selectedLodgingIsFavorited: action.selectedLodgingIsFavorited,
      };
    case SET_HOTEL_DETAILS_ENTRY_SOURCE:
      return {
        ...state,
        hotelDetailsEntrySource: action.hotelDetailsEntrySource,
      };

    case SET_ALLOWED_PAY_LATER_LODGING_IDS:
      return {
        ...state,
        allowedPayLaterLodgingIds: action.allowedPayLaterLodgingIds,
      };

    case SET_LIFESTYLE_ELIGIBILITY:
      return {
        ...state,
        isLifestyleEligible: action.isEligible,
      };

    default:
      return { ...state };
  }
};

export * from "./selectors";
